import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e62385a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal-list-drawer" }
const _hoisted_2 = { class: "filter-row" }
const _hoisted_3 = {
  style: {"display":"flex"},
  class: "cm-ui-mr10"
}
const _hoisted_4 = { style: {"display":"flex"} }

import { ref, reactive, computed, watch, nextTick } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import CmTable from '@/components/cmTable/index.vue'
import CmForm from '@/components/cmForm/index.vue'
import { SubnetStatusItem } from '../subnet-status/subnet-status.service'
import { InstalledTerminalDrawerService } from './installed-terminal-drawer.service'
import { FormActionType, FormSize, FormType, ObjectFormItem } from '@/components/cmForm/types'
import BtnIcon from '@/views/dashboard/_components/btn-icon/btn-icon.vue'
import { TerminalTypeOptions } from '@/views/dashboard/_enum/terminal-type'
import GroupTreeSelector from '@/views/dashboard/_components/group-tree-selector/group-tree-selector.vue'
import { calculateSubnetInfo } from '@/utils'
import { useI18n } from 'vue-i18n'
import ExportDropdown from '@/views/dashboard/_components/export-dropdown/export-dropdown.vue'
import { listCol } from '@/utils/list-columns-i18n'
import { computerInfoCols } from '@/views/dashboard/data-safe/ransomware-protection/types/ransomware-incident'


export default /*#__PURE__*/_defineComponent({
  __name: 'installed-terminal-drawer',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  },
  subnetData: {
    type: Object as () => SubnetStatusItem | null,
    default: null
  },
  hasPermission: {
    type: Boolean,
    default: true
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const { t, locale } = useI18n()

const props = __props

const hasPermission = computed(() => props.hasPermission)

const emit = __emit

const drawerVisible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

const injector = useReflectiveInjector([InstalledTerminalDrawerService])
const service = injector.get(InstalledTerminalDrawerService)

const tableRef = ref<any>()
const { refreshList } = useCmTableListRefresh(tableRef)
const totalCount = computed(() => tableRef.value?.total || 0)

const drawerTitle = computed(() => {
  const subnetAddress = props.subnetData?.subnet_address || ''
  return subnetAddress ? t('installedDrawer.titleWithAddress', { address: subnetAddress }) : t('installedDrawer.titleShort')
})

const form = reactive({
  subnet_address: props.subnetData?.subnet_address || '',
  group_id: -1,
  system_type: undefined as number | undefined,
  keyword: ''
})

const formColumns = computed<ObjectFormItem<typeof form, 'group_id' | 'system_type' | 'keyword'>>(() => {
  void locale.value
  return {
    group_id: {
      colOpt: { style:'flex:0 0 150px' },
      slot: true,
      hiddenAllLabel: true,
      type: FormType.Select,
      placeholder: t('discoveredList.groupPlaceholder'),
    },
    system_type: {
      colOpt: { style: 'width: 150px;flex:0 0 auto' },
      hiddenAllLabel: true,
      type: FormType.Select,
      placeholder: t('discoveredList.osPlaceholder'),
      selectOpt: {
        clearable: true,
      },
      dictData: TerminalTypeOptions,
      events: {
        change: () => void refreshList(),
      }
    },
    keyword: {
      colOpt: { style: 'flex: 0 0 300px' },
      hiddenAllLabel: true,
      placeholder: t('discoveredList.searchPlaceholder'),
      modelModifiers: { trim: true },
      inputOpt: {
        'suffix-icon': 'el-icon-search',
      },
      events: {
        blur: () => void refreshList(),
        keypress: (e: any) => e.charCode === 13 && void refreshList()
      }
    }
  }
})

const pageOption = {
  pageNumName: 'page',
  pageSizeName: 'limit'
}

const tableOpt = computed(() => {
  void locale.value
  return {
    columns: [
     ...computerInfoCols(false,false,t)
    ],
    bodyStyle: { padding: 0 },
    showActionBar: false,
    showSearch: false,
    showRightToolbar: true,
    height: '100%',
    path: 'list'
  }
})

function getListApi(params: any) {
  const info = calculateSubnetInfo(props.subnetData?.subnet_address || '')
  return service.getInstalledTerminalList({
    subnet_address_start: props.subnetData.subnet_address ? info.fullRangeStart:undefined,
    subnet_address_end: props.subnetData.subnet_address ? info.fullRangeEnd:undefined,
    keyword: form.keyword,
    limit: params.limit,
    page: params.page,
    group_id: form.group_id,
    system_type: form.system_type
  })
}

function updateGroupId(groupId: number) {
  nextTick(() => {
    form.group_id = groupId
    void refreshList()
  })
}

watch(() => drawerVisible.value, (visible) => {
  if (visible) {
    form.subnet_address = props.subnetData?.subnet_address || ''
    form.group_id = -1
    form.system_type = undefined
    form.keyword = ''
    void refreshList()
  }
})

function download(type: 0 | 1) {
  const info = calculateSubnetInfo(props.subnetData?.subnet_address || '')
  service.downloadInstalledTerminalList(type, {
    subnet_address_start: props.subnetData?.subnet_address ? info.fullRangeStart:undefined,
    subnet_address_end: props.subnetData?.subnet_address ? info.fullRangeEnd:undefined,
    ...form,
    limit: 0,
    page: 0,
  }, t('installedDrawer.exportFileName'))
}

return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: drawerVisible.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((drawerVisible).value = $event)),
    title: drawerTitle.value,
    size: "60%",
    "append-to-body": "",
    "destroy-on-close": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ExportDropdown, {
              "has-permission": hasPermission.value,
              "csv-i18n-key": "installedDrawer.exportCsv",
              "excel-i18n-key": "installedDrawer.exportExcel",
              onExport: download
            }, null, 8, ["has-permission"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(CmForm, {
              modelValue: form,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form) = $event)),
              rowOpt: { style: 'justify-content:flex-end' },
              formSize: _unref(FormSize).Small,
              formColumns: formColumns.value,
              formType: _unref(FormActionType).Other,
              "onUpdate:formType": _cache[1] || (_cache[1] = ($event: any) => ((_unref(FormActionType).Other) = $event))
            }, {
              group_id: _withCtx(() => [
                _createVNode(GroupTreeSelector, {
                  subnet_address: __props.subnetData.subnet_address,
                  disabled: !hasPermission.value,
                  onSelected: updateGroupId
                }, null, 8, ["subnet_address", "disabled"])
              ]),
              _: 1
            }, 8, ["modelValue", "formSize", "formColumns", "formType"])
          ])
        ]),
        _createVNode(CmTable, {
          ref_key: "tableRef",
          ref: tableRef,
          "table-opt": tableOpt.value,
          api: getListApi,
          "has-permission": hasPermission.value,
          modelValue: form,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form) = $event)),
          "page-option": pageOption
        }, null, 8, ["table-opt", "has-permission", "modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})